import request from "@/utils/request";
const baseUrl = process.env.VUE_APP_APP_API + "/pm/dict";
const dictApi = {
  // 地区 根据 areaCode 获取下级地区
  areaList(areaCode) {
    return request({
      url: `${baseUrl}/area-list`,
      method: "GET",
      params: { areaCode }
    });
  }
};
export default dictApi;
